const KEY = "af_signup_attribution";
const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
const VALUE_RE = /^[A-Za-z0-9 ._+-]{1,100}$/;

// First touch in this browser session: allowlisted UTM values and the external referrer's hostname only.
export function captureSignupAttribution() {
  try {
    if (sessionStorage.getItem(KEY)) return;
    const params = new URLSearchParams(window.location.search);
    const out = {};
    UTM_KEYS.forEach((k) => {
      const v = (params.get(k) || "").trim();
      if (VALUE_RE.test(v)) out[k] = v;
    });
    if (document.referrer) {
      const host = new URL(document.referrer).hostname.toLowerCase();
      if (host && host !== window.location.hostname.toLowerCase()) out.referrer_host = host;
    }
    if (Object.keys(out).length) sessionStorage.setItem(KEY, JSON.stringify(out));
  } catch { /* Attribution is optional. */ }
}

export function getSignupAttribution() {
  try {
    return JSON.parse(sessionStorage.getItem(KEY) || "null") || undefined;
  } catch {
    return undefined;
  }
}
